module.exports = __webpack_public_path__ + "img/220-Veka Spectral C34-Umbra.png";